// export DsfVirtualTree from './virtualTree.vue'

export const DsfVirtualTree =Vue.defineLazyComponent(()=>require('./virtualTree.vue'))